// 客户转化路由
import Layout from '@/view/layout' // 主框架

export default {
  path: '/customerConversion',
  component: Layout,
  children: [
    {
      path: 'welcomeLanguage',
      component: () => import('@/view/customerConversion/welcomeLanguage'),
      name: '欢迎语'
    },
    {
      path: 'welcomeLanguage/:id',
      component: () => import('@/view/customerConversion/welcomeLanguageEdit'),
      name: '欢迎语编辑'
    },
    {
      path: 'materialLibrary',
      component: () => import('@/view/library/index'),
      name: '素材库'
    },
    {
      path: 'performanceDistribution',
      component: () => import('@/view/performanceDistribution/list'),
      name: '业绩配比'
    },
    {
      path: 'performanceDistribution/:id',
      component: () => import('@/view/performanceDistribution/edit'),
      name: '业绩配比新增或编辑'
    },
    {
      path: 'commissionSettings',
      component: () => import('@/view/commissionSettings/index.vue'),
      name: '佣金设置'
    },
    {
      path: 'commissionReport',
      component: () => import('@/view/customerConversion/commissionReport.vue'),
      name: '提成报表'
    },
    {
      path: 'commissionReport/:id',
      component: () => import('@/view/customerConversion/commissionDetail.vue'),
      name: '提成明细'
    }
  ]
}
